(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-jivosite", [], factory);
	else if(typeof exports === 'object')
		exports["react-jivosite"] = factory();
	else
		root["react-jivosite"] = factory();
})(global, function() {
return 